import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_LOCAL_API_REQUESTS } from './constants';

export const getStrength = async (projectId, assignmentId, lastKey) => {
  const basePath = `projects/${projectId}/renolog/assignments/${assignmentId}/strength`;
  const params = new URLSearchParams({ limit: 1000 });
  if (lastKey) params.set('lastKey', lastKey);
  const apiPath = `${basePath}?${params.toString()}`;
  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: RENOLOG_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
